import { PortalInstance } from "@mezo/sdk"

import createDappAsyncThunk from "../asyncThunk"

type EstimateGasArguments<
  Method extends keyof PortalInstance,
  MethodArguments extends Parameters<PortalInstance[Method]>,
> = {
  contractMethod: Method
  contractArguments: MethodArguments
}

export const estimateGas = <
  Method extends keyof PortalInstance,
  MethodArguments extends Parameters<PortalInstance[Method]>,
>(
  args: EstimateGasArguments<Method, MethodArguments>,
) =>
  createDappAsyncThunk<
    | {
        gasEstimation: bigint
        gasPrice: bigint
      }
    | undefined,
    EstimateGasArguments<Method, MethodArguments>
  >(
    "wallet/estimateGas",
    async ({ contractMethod, contractArguments }, { extra: { sdk } }) => {
      const gasEstimation = await sdk.mezo.chain?.portalContract.estimateGas(
        contractMethod,
        contractArguments,
      )

      return gasEstimation
    },
  )(args)

export const getGasFeeData = createDappAsyncThunk(
  "wallet/getGasFeeData",
  async (_, { extra: { sdk } }) => {
    const gasFeeData = await sdk.mezo.chain?.portalContract.getGasFeeData()

    return gasFeeData
  },
)
